export default "__VITE_ASSET__C8CvcnGS__"